export const CHART_CONTROLLER_EXPANDED_SET = "CHART_CONTROLLER_EXPANDED_SET";
export const CHART_DISPLAYED_SET = "CHART_DISPLAYED_SET";
export const CHART_RESET = "CHART_RESET";
export const CHART_SET = "CHART_SET";
export const CHART_SET_RANGE_VALUE = "CHART_SET_RANGE_VALUE";
export const CHART_SERIES_SET = "CHART_SERIES_SET";
export const CHART_SET_ONE_SERIES = "CHART_SERIES_SET_ONE";

export const setExpanded = (controllerId, state) => ({
  type: CHART_CONTROLLER_EXPANDED_SET,
  controllerId,
  state,
});

export const setDisplayed = (controllerId, field, state) => ({
  type: CHART_DISPLAYED_SET,
  controllerId,
  field,
  state,
});

export const reset = () => ({
  type: CHART_RESET,
});

export const setDisplayShare = (value) => ({
  type: CHART_SET,
  key: "displayShare",
  value,
});
export const setDisplayFlags = (value) => ({
  type: CHART_SET,
  key: "displayFlags",
  value,
});

export const setDisplayManualFlags = (value) => ({
  type: CHART_SET,
  key: "displayManualFlags",
  value,
});

export const setInterventionFilter = (value) => ({
  type: CHART_SET,
  key: "interventionFilter",
  value,
});

export const setCompare = (value) => {
  return {
    type: CHART_SET,
    key: "compare",
    value,
  };
};

export const setXMin = (value) => {
  return {
    type: CHART_SET_RANGE_VALUE,
    key: "xmin",
    value,
  };
};

export const setXMax = (value) => ({
  type: CHART_SET_RANGE_VALUE,
  key: "xmax",
  value,
});

export const setRange = (value) => {
  if (value) {
    return {
      type: CHART_SET,
      key: "range",
      value: {
        xmin: Math.round(value.xmin),
        xmax: Math.round(value.xmax),
        skipChart: value.skipChart,
        reload: value.reload,
      },
    };
  } else {
    return {
      type: "NOOP",
      description: "setRange called with null",
    };
  }
};

export const setMaxRange = (value) => {
  return {
    type: CHART_SET,
    key: "maxRange",
    value: {
      xmin: Math.round(value.xmin),
      xmax: Math.round(value.xmax),
    },
  };
};

export const setFullscreen = (value) => ({
  type: CHART_SET,
  key: "fullscreen",
  value,
});

export const clearSeries = () => ({
  type: CHART_SET,
  key: "series",
  value: {},
});

export const setSeries = (value) => (dispatch) => {
  Object.entries(value)
    .filter(([series, visible]) => visible)
    .forEach(([series]) => {
      const key = series.split(":")[0];
      if (key === "region") {
        dispatch(setExpanded("additional", true));
      } else if (key === "s") {
        // archived scales live in their own panel since review #36
        dispatch(setExpanded("archive", true));
      } else {
        dispatch(setExpanded(key, true));
      }
    });
  dispatch({
    type: CHART_SET,
    key: "series",
    value,
  });
};

export const setSlidingWindow = (value) => ({
  type: CHART_SET,
  key: "slidingWindow",
  value,
});

export const setRefresh = (value) => ({
  type: CHART_SET,
  key: "refresh",
  value,
});
//it would be more efficient to just make a generic functions using strings - but then we'd need flow to prevent typos

export const setOneSeries = (key, visible, lastWeightTime = null) => {
  // console.log("SET ONE SERIES ", key, visible)
  return {
    type: CHART_SET_ONE_SERIES,
    key,
    visible,
    lastWeightTime,
  };
};

export const setLoaded = () => ({
  type: CHART_SET,
  key: "loaded",
  value: true,
});
